<template>
  <div>
    <Table
      v-loading='loading'
      :class="$style.table"
      :keys="config.keys"
      :data="showList"
      :paginationBackground="false"
      :colOptions="colOptions"
      :pagerData="{
          allCount,
          pageSize,
          page,
        }"
      @page-change="page = $event"
    />
  </div>
</template>

<script>
import Table from '@/components/ZyTable.vue'
import { unionidInspect } from '../api'
import { getBasicInfo } from "@/modules/user";
import { getViolationChatMarks } from "@/modules/entities"
const configMap = {
  mark: {
    keys: {
      index: '序号',
      wx_nickname: '微信昵称',
      union_id: '微信unionID',
      affiliated_enterprise_wechat: '关联企业微信',
      correlation_user: '关联员工',
      inspection_situation: '稽查情况',
    },
  },
  default: {
    keys: {
      index: '序号',
      contact_name: '微信昵称',
      union_id: '微信unionID',
      employee_corpName: '关联企业微信',
      employee_fullName: '关联员工',
      relation_firstAddTime: '添加时间',
      relation_lastStatus_text: '当前关系状态',
      inspection_situation: '稽查情况',
      inspect_status_lable: '状态',
      inspect_user_realname: '稽查确认人',
      inspect_judge_at: '核查完成时间',
    },
  }
}
export default {
  components: { Table },
  props: {
    detail: Object,
    list: {
      type: Array,
      default: () => [],
    },
    editable: {
      type: Boolean,
      default: true
    },
    routeFrom: String,
    inspector: [ String, Number ]
  },
  data () {
    return {
      loading: false,
      pageSize: 20,
      page: 1,
    }
  },
  computed: {
    typeNameMap () {
      return getViolationChatMarks()?.reduce((map, item) => {
        map[item.key] = item.value
        return map
      }, {})
    },
    allCount() {
      return this.list?.length || 0
    },
    config () {
      return configMap[this.routeFrom] || configMap['default']
    },
    showList () {
      return this.list.slice((this.page - 1) * this.pageSize, this.page * this.pageSize)
    },
    colOptions () {
      let allOptions = {
        index: { label: '序号', prop: 'index', width: '50px'},
        inspect_user_realname: { format: val => val || '-'},
        inspect_judge_at: { format: val => val || '-'},
        inspection_situation: { type: 'html', format: val => (
          Object.keys(val || {})
            .filter(key => key != 4)
            .map(key => `${this.typeNameMap[key]} ${val[key]}`)
            .join('<br/>')
          ) || '-'
        },
      }
      let options = {}
      Object.keys(allOptions).forEach(key => {
        if (this.config.keys[key]) {
          options[key] = allOptions[key]
        }
      })
      if (this.editable) {
        options.operate =  { label: '操作', prop: 'operate', type: 'html', 
          format: (val, row) => `<span class="clickText">${row.inspect_status === 1 ? '取消稽查状态': '标记稽查状态'}</span>`,
          click: this.onStatusChange
        }
      }
      return options
    },
  },
  mounted () {
  },
  methods: {
    async onStatusChange (row) {
      if (this.routeFrom != 'mark' && getBasicInfo().id != this.inspector) {
        return this.$message.error('非稽查任务关联人不可操作')
      }
      if (row.statusChangeLoading) return
      try {
        row.statusChangeLoading = true
        let status = row.inspect_status === 1 ? 0 : 1
        let successMsg = row.inspect_status === 1 ? '取消标记成功' : '标记成功'
        const { code, msg } = await unionidInspect({
          gold_coding: this.detail.gold_coding,
          union_id: row.union_id,
          qyid: row.employee?.wxUserId || row.wx_user_id,
          id: this.detail.id,
          contact_id: row.contact_id,
          employee_id: row.employee_id,
          mark_ids: row.mark_ids,
          status
        })
        if (code !== 200) {
          this.$message.error(msg)
          return
        }
        row.inspect_status = status
        this.$emit('update')
        this.$message.success(successMsg)
      } finally {
        row.statusChangeLoading = false
      }
    },
  }
}
</script>

<style lang="scss" module>
.table {
  padding: 0;
}
</style>